import * as ToggleMenuFlyout from '@ori-events/toggle-menu-flyout';
import * as UserAction from '@ori-events/user-action';

import { CLICK_BURGER_MENU } from '../constants';
import { useActiveMenu } from '../context/navigation/activeMenuContext';
import { dispatchToggleMenu } from '../utils';

const toggleMenu = () => {
  UserAction.dispatch(CLICK_BURGER_MENU);
  dispatchToggleMenu(ToggleMenuFlyout.MenuTypes.BurgerMenu);
};

export const useToggleMenu = () => {
  const { activeMenu } = useActiveMenu();

  return [activeMenu === ToggleMenuFlyout.MenuTypes.BurgerMenu, toggleMenu] as const;
};
